import React from 'react';
import { Alert } from 'antd';
import { Link } from '@/intl/navigation';
import { useTranslations } from 'next-intl';
import appRoutes from '@/constants/routes';
import { contacts } from '@/constants';

type Props = {
  errorType: ErrorType;
};

export enum ErrorType {
  NOT_FOUND = 'NOT_FOUND',
  BAD_REQUEST = 'BAD_REQUEST',
  UNEXPECTED = ' UNEXPECTED',
  DENIED = 'DENIED',
  CONFLICT = 'CONFLICT',
  NONE = 'NONE',
}

export default function ErrorAlert({ errorType }: Props) {
  const t = useTranslations('auth');

  if (errorType == ErrorType.UNEXPECTED) {
    return <AlertWrapper message={t('forms.apiResponse.serverError')} />;
  } else if (errorType == ErrorType.NOT_FOUND) {
    return (
      <AlertWrapper
        message={t('forms.apiResponse.notFound')}
        description={
          <Link className="hover:underline" href={appRoutes.signup}>
            {t('createAccount')}
          </Link>
        }
      />
    );
  } else if (errorType == ErrorType.BAD_REQUEST) {
    return (
      <AlertWrapper
        message={t('forms.apiResponse.wrongCredentials')}
        description={
          <Link className="hover:underline" href={appRoutes.resetPassword}>
            {t('forgotPassword')}
          </Link>
        }
      />
    );
  } else if (errorType == ErrorType.DENIED) {
    return (
      <AlertWrapper
        message={t('forms.apiResponse.accessDenied')}
        description={
          <Link
            className="hover:underline"
            href={contacts.afiwaSocials['whatsapp'].link}
          >
            {'WhatsApp'}
          </Link>
        }
      />
    );
  } else if (errorType == ErrorType.CONFLICT) {
    return (
      <AlertWrapper
        message={t('forms.apiResponse.conflict')}
        description={
          <Link className="hover:underline" href={appRoutes.login}>
            {t('login')}
          </Link>
        }
      />
    );
  } else {
    return null;
  }
}

const AlertWrapper = ({
  message,
  description,
}: {
  message: string;
  description?: React.ReactNode;
}) => {
  return (
    <Alert
      className="mb-4"
      closeIcon={false}
      message={message}
      type="error"
      rootClassName="!mb-6"
      {...(description && { description })}
    />
  );
};
